import { Button, Dialog, DialogContent, Icons } from '@commenda/kakashi';
import { useState } from 'react';

interface IndirectTaxBulkDeleteTransactionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
  totalSelected: number;
}

const IndirectTaxBulkDeleteTransactionsModal = ({
  isOpen,
  onClose,
  onDelete,
  totalSelected,
}: IndirectTaxBulkDeleteTransactionsModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };

  return (
    <Dialog open={isOpen}>
      <DialogContent
        className="min-w-[600px] p-none"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <div className="p-3xl flex flex-col gap-xl">
          <div className="flex items-center justify-center size-12 bg-bg-error rounded-lg">
            <Icons.Trash01 className="size-5 text-text-error" />
          </div>

          <div className="flex flex-col gap-4xl">
            <div className="flex flex-col gap-xxs">
              <h3 className="text-text-primary txt-large-bold">
                Delete {totalSelected}{' '}
                {totalSelected === 1 ? 'transaction' : 'transactions'}?
              </h3>
              <p className="txt-small-regular text-text-tertiary">
                The selected{' '}
                {totalSelected === 1 ? 'transaction' : 'transactions'} will be
                deleted permanently. This action cannot be undone.
              </p>
            </div>

            <div className="flex gap-md items-center justify-end">
              <Button
                variant="secondary"
                onClick={onClose}
                size="sm"
                disabled={isDeleting}
              >
                Cancel
              </Button>
              <Button
                variant="destructive-primary"
                onClick={handleDelete}
                size="sm"
                disabled={isDeleting}
              >
                Delete {totalSelected === 1 ? 'transaction' : 'transactions'}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { IndirectTaxBulkDeleteTransactionsModal };
